import { Location } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  FormGroupDirective,
  Validators
} from '@angular/forms';
import { Router } from '@angular/router';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { Subscription } from 'rxjs';
import { VinInfo } from 'src/app/helpers';
import { AuthService } from 'src/app/services/auth/auth.service';
import { UserService } from 'src/app/services/user-service/user.service';
import { SharedService } from 'src/app/services/shared/shared.service';
import { ToastrService } from 'ngx-toastr';
import { NgxImageCompressService } from 'ngx-image-compress';
import * as moment from 'moment';
import { environment } from 'src/environments/environment';
import { tap } from 'rxjs/operators';
import { IsDeviceOnlineService } from 'src/app/services/is-online/is-online.service';
import { HttpErrorResponse } from '@angular/common/http';
import { IBaseResponse } from 'src/app/model/common.model';
declare var $: any;
@Component({
  selector: 'app-validation',
  templateUrl: './validation.component.html',
  styleUrls: ['./validation.component.scss']
})
export class ValidationComponent implements OnInit {
  public estExpToggle: boolean = false;
  public mvpiExpToggle: boolean = false;

  public submitted: boolean = false;
  public submitLoad: boolean = false;
  public validation: UntypedFormGroup = null;
  @ViewChild('validationFormDirective', { static: false })
  validationFormDirective: FormGroupDirective;

  public vinInfo: VinInfo = new VinInfo();

  public file: File = null;
  public file2: File = null;
  public file3: File = null;
  public file4: File = null;
  public file5: File = null;
  public fileBase64: ArrayBuffer | string = null;
  public file2Base64: ArrayBuffer | string = null;
  public file3Base64: ArrayBuffer | string = null;
  public file4Base64: ArrayBuffer | string = null;
  public file5Base64: ArrayBuffer | string = null;
  public extErrorFile: boolean = false;
  public extErrorFile2: boolean = false;
  public extErrorFile3: boolean = false;
  public extErrorFile4: boolean = false;
  public extErrorFile5: boolean = false;

  public vehicle_info: vehicle_info = {
    vehicle_id: null
  };

  public authUnsubscribe: Subscription = new Subscription();
  public form = new FormData();
  public dpConfig: Partial<BsDatepickerConfig> = new BsDatepickerConfig();

  constructor(
    public formBuilder: UntypedFormBuilder,
    public router: Router,
    public location: Location,
    public authService: AuthService,
    public userService: UserService,
    public sharedService: SharedService,
    public toastr: ToastrService,
    private imageCompress: NgxImageCompressService,
    private readonly _isDeviceOnlineService: IsDeviceOnlineService
  ) {
    this.validation = this.formBuilder.group({
      vin: [
        '',
        [
          Validators.required,
          Validators.maxLength(21),
          Validators.pattern(/^(?=.*[0-9])(?=.*[a-zA-Z])([a-zA-Z0-9]+)$/)
        ]
      ],
      plate: ['', [Validators.pattern(/^(?=.*[0-9])(?=.*[a-zA-Z])([a-zA-Z0-9 ]+)$/)]],

      odo: ['', [Validators.required, Validators.pattern(/^[0-9.]+$/)]],
      est_exp_date: [''],
      mvpi_exp_date: [''],

      vin_img: ['', [Validators.required]],
      plate_img: [''],
      odo_img: ['', [Validators.required]],
      est_img: [''],
      mvpi_img: [''],

      vin_confirm: [false, [Validators.requiredTrue]],
      plate_confirm: [false],
      odo_confirm: [false, [Validators.requiredTrue]],
      estemara_confirm: [false],
      mvpi_confirm: [false]
    });

    // this.AuthUserData();
    this.vehicle_info.vehicle_id = this.sharedService.getVehicleId;

    this.dpConfig.dateInputFormat = 'DD-MM-YYYY';
    this.dpConfig.adaptivePosition = true;
    this.dpConfig.showWeekNumbers = false;
  }

  ngOnInit(): void {
    this.getVinDetails();

    this.validation.get('est_exp_date').valueChanges.subscribe((res) => {});
  }

  ngOnDestroy() {
    //Unsubscribing the user details as moving to another component to keep the data previously
    this.authUnsubscribe.unsubscribe();
  }

  // AuthUserData() {
  //   //Subscribing the user details as moving to another component to keep the data previously
  //   this.authUnsubscribe = this.authService.user
  //     .subscribe(
  //       (res) => {
  //         if (res) {
  //           let userDetails = res['user']['user_data'];
  //         }
  //       }
  //     )
  // }

  getVinDetails() {
    this.userService
      .GetVinInfo(this.vehicle_info)
      .pipe(tap((res) => {}))
      .subscribe(
        (res) => {
          let success = res['success'];
          let data = res['data'];

          if (success && Object.keys(data).length) {
            let vehicleDetails: Object = data['vehicle_details'];
            let url: string = `${environment.base_path}storage/vehicle/`;

            this.vinInfo.vin_number = vehicleDetails['vin_number'];
            this.vinInfo.plate_number = vehicleDetails['plate_number'];
            this.vinInfo.odo = vehicleDetails['odo_value'];
            this.vinInfo.est_exp_date = vehicleDetails['estimara_expiry_date']
              ? moment(vehicleDetails['estimara_expiry_date'], 'Y-M-D').format('DD-MM-YYYY')
              : '';
            this.vinInfo.mvpi_exp_date = vehicleDetails['mvpi_expiry_date']
              ? moment(vehicleDetails['mvpi_expiry_date'], 'Y-M-D').format('DD-MM-YYYY')
              : '';
            this.vinInfo.odo = vehicleDetails['odo_value'];

            if (this._isDeviceOnlineService.currentNetwork === 'online') {
              this.fileBase64 = vehicleDetails['vin_image']
                ? `${url}vinimage/${vehicleDetails['vin_image']}`
                : '';
              this.file2Base64 = vehicleDetails['plate_image']
                ? `${url}plateimage/${vehicleDetails['plate_image']}`
                : '';
              this.file3Base64 = vehicleDetails['odo_image']
                ? `${url}odo-image/${vehicleDetails['odo_image']}`
                : '';
              this.file4Base64 = vehicleDetails['estimara_image']
                ? `${url}estimaraimage/${vehicleDetails['estimara_image']}`
                : '';
              this.file5Base64 = vehicleDetails['mvpi_image']
                ? `${url}mvpiimage/${vehicleDetails['mvpi_image']}`
                : '';
            } else {
              this.fileBase64 = vehicleDetails['vin_image'] ? `${vehicleDetails['vin_image']}` : '';
              this.file2Base64 = vehicleDetails['plate_image']
                ? `${vehicleDetails['plate_image']}`
                : '';
              this.file3Base64 = vehicleDetails['odo_image']
                ? `${vehicleDetails['odo_image']}`
                : '';
              this.file4Base64 = vehicleDetails['estimara_image']
                ? `${vehicleDetails['estimara_image']}`
                : '';
              this.file5Base64 = vehicleDetails['mvpi_image']
                ? `${vehicleDetails['mvpi_image']}`
                : '';
            }

            if (this.fileBase64) {
              this.validation.get('vin_img').clearValidators();
              this.validation.get('vin_img').updateValueAndValidity();
            }

            if (this.file3Base64) {
              this.validation.get('odo_img').clearValidators();
              this.validation.get('odo_img').updateValueAndValidity();
            }

            this.validation.get('vin').setValue(this.vinInfo.vin_number);
            this.validation.get('plate').setValue(this.vinInfo.plate_number);
            this.validation.get('odo').setValue(this.vinInfo.odo);
            this.validation.get('est_exp_date').setValue(this.vinInfo.est_exp_date);
            this.validation.get('mvpi_exp_date').setValue(this.vinInfo.mvpi_exp_date);

            this.hijriChecker(this.vinInfo.est_exp_date, 'estemara');
            this.hijriChecker(this.vinInfo.mvpi_exp_date, 'mvpi');

            this.validation.updateValueAndValidity();
          }
        },
        (error) => {}
      );
  }

  get formData() {
    return this.validation.controls;
  }

  File(evt: Event, type: string) {
    const reader: FileReader = new FileReader();
    // Validating four file type fields in one function depending on type variable
    switch (type) {
      case 'vin':
        {
          const file: File = evt.target['files'][0];

          if (
            file.type === 'image/png' ||
            file.type === 'image/jpg' ||
            file.type === 'image/jpeg'
          ) {
            this.extErrorFile = false;
            this.validation.get('vin_img').setValue(file);
            this.validation.updateValueAndValidity();

            reader.readAsDataURL(file);
            reader.onload = (event) => {
              if (event.target.result) {
                this.fileBase64 = event.target.result;
                this.imageCompression(<string>this.fileBase64, file.name, type);
              }
            };
          } else {
            this.extErrorFile = true;
            evt.target['value'] = '';
          }
        }
        break;

      case 'plate':
        {
          const file2: File = evt.target['files'][0];

          if (
            file2.type === 'image/png' ||
            file2.type === 'image/jpg' ||
            file2.type === 'image/jpeg'
          ) {
            this.extErrorFile2 = false;
            this.validation.get('plate_img').setValue(file2);
            this.validation.updateValueAndValidity();

            reader.readAsDataURL(file2);
            reader.onload = (event) => {
              if (event.target.result) {
                this.file2Base64 = event.target.result;
                this.imageCompression(<string>this.file2Base64, file2.name, type);
              }
            };
          } else {
            this.extErrorFile2 = true;
          }
        }
        break;

      case 'odo':
        {
          const file3: File = evt.target['files'][0];

          if (
            file3.type === 'image/png' ||
            file3.type === 'image/jpg' ||
            file3.type === 'image/jpeg'
          ) {
            this.extErrorFile3 = false;
            this.validation.get('odo_img').setValue(file3);
            this.validation.updateValueAndValidity();

            reader.readAsDataURL(file3);
            reader.onload = (event) => {
              if (event.target.result) {
                this.file3Base64 = event.target.result;
                this.imageCompression(<string>this.file3Base64, file3.name, type);
              }
            };
          } else {
            this.extErrorFile3 = true;
          }
        }
        break;

      case 'istimara':
        {
          const file4: File = evt.target['files'][0];

          if (
            file4.type === 'image/png' ||
            file4.type === 'image/jpg' ||
            file4.type === 'image/jpeg'
          ) {
            this.extErrorFile4 = false;
            this.validation.get('est_img').setValue(file4);
            this.validation.updateValueAndValidity();

            reader.readAsDataURL(file4);
            reader.onload = (event) => {
              if (event.target.result) {
                this.file4Base64 = event.target.result;
                this.imageCompression(<string>this.file4Base64, file4.name, type);
              }
            };
          } else {
            this.extErrorFile4 = true;
          }
        }
        break;

      case 'MVPI':
        {
          const file5: File = evt.target['files'][0];

          if (
            file5.type === 'image/png' ||
            file5.type === 'image/jpg' ||
            file5.type === 'image/jpeg'
          ) {
            this.extErrorFile5 = false;
            this.validation.get('mvpi_img').setValue(file5);
            this.validation.updateValueAndValidity();

            reader.readAsDataURL(file5);
            reader.onload = (event) => {
              if (event.target.result) {
                this.file5Base64 = event.target.result;
                this.imageCompression(<string>this.file5Base64, file5.name, type);
              }
            };
          } else {
            this.extErrorFile5 = true;
          }
        }
        break;
    }
  }

  imageCompression(base64: string, fileName: string, type: string) {
    this.imageCompress.compressFile(base64, -1, 60, 50).then((res) => {
      switch (type) {
        case 'vin':
          const imageVin = this.sharedService.dataURItoBlob(res.split(',')[1]);
          this.file = new File([imageVin], fileName, { type: 'image/jpeg' });
          break;
        case 'plate':
          const imagePlate = this.sharedService.dataURItoBlob(res.split(',')[1]);
          this.file2 = new File([imagePlate], fileName, { type: 'image/jpeg' });
          break;
        case 'odo':
          const imageOdo = this.sharedService.dataURItoBlob(res.split(',')[1]);
          this.file3 = new File([imageOdo], fileName, { type: 'image/jpeg' });
          break;
        case 'istimara':
          const imageEstimara = this.sharedService.dataURItoBlob(res.split(',')[1]);
          this.file4 = new File([imageEstimara], fileName, {
            type: 'image/jpeg'
          });
          break;
        case 'MVPI':
          const imageMVPI = this.sharedService.dataURItoBlob(res.split(',')[1]);
          this.file5 = new File([imageMVPI], fileName, { type: 'image/jpeg' });
          break;
      }
    });
  }

  dpToggle(type: string) {
    switch (type) {
      case 'estemara':
        const estDate = this.vinInfo.est_exp_date || '';
        const hijriYearEst: string | number = moment(
          this.vinInfo.est_exp_date,
          'DD-MM-YYYY'
        ).year();

        this.estExpToggle = !this.estExpToggle;

        if (this.estExpToggle) {
          setTimeout(() => {
            // Islamic DP
            $('#est_exp_date').hijriDatePicker({
              hijri: true,
              hijriFormat: 'iD-iM-iYYYY',
              locale: 'en-us',
              showSwitcher: false
            });

            hijriYearEst <= 1599
              ? this.validation.get('est_exp_date').setValue(estDate)
              : this.validation.get('est_exp_date').setValue('');

            this.validation.get('est_exp_date').updateValueAndValidity({
              onlySelf: true,
              emitEvent: true
            });
            // END
          }, 0);

          return;
        }

        hijriYearEst > 1599
          ? this.validation.get('est_exp_date').setValue(this.vinInfo.est_exp_date || '')
          : this.validation.get('est_exp_date').setValue('');
        break;
      case 'mvpi':
        const mvpiDate = this.vinInfo.mvpi_exp_date || '';
        const hijriYearMVPI: string | number = moment(
          this.vinInfo.mvpi_exp_date,
          'DD-MM-YYYY'
        ).year();

        this.mvpiExpToggle = !this.mvpiExpToggle;

        if (this.mvpiExpToggle) {
          setTimeout(() => {
            // Islamic DP
            $('#mvpi_exp_date').hijriDatePicker({
              hijri: true,
              hijriFormat: 'iD-iM-iYYYY',
              locale: 'en-us',
              showSwitcher: false
            });

            hijriYearMVPI <= 1599
              ? this.validation.get('mvpi_exp_date').setValue(mvpiDate)
              : this.validation.get('mvpi_exp_date').setValue('');

            this.validation.get('mvpi_exp_date').updateValueAndValidity({
              onlySelf: true,
              emitEvent: true
            });
            // END
          }, 0);

          return;
        }

        hijriYearMVPI > 1599
          ? this.validation.get('mvpi_exp_date').setValue(this.vinInfo.mvpi_exp_date || '')
          : this.validation.get('mvpi_exp_date').setValue('');
        break;
    }
  }

  hijriChecker(date: Date | string, type: string) {
    const hijriYear: string | number = moment(date, 'DD-MM-YYYY').year();

    if (hijriYear <= 1599) this.dpToggle(type);
  }

  openImage(elem: HTMLElement) {
    let newTab = window.open();

    setTimeout(() => {
      newTab.document.body.innerHTML = elem.innerHTML;
    }, 100);

    return false;
  }

  validate() {
    //Validation all the fields
    let estExpDate: string = null;
    let mvpiExpDate: string = null;

    if (this.estExpToggle) {
      let estExpVal = document.querySelector('#est_exp_date')['value'];
      this.validation.get('est_exp_date').setValue(estExpVal);
      this.validation.updateValueAndValidity();

      estExpDate = this.validation.value.est_exp_date
        ? moment(this.validation.value.est_exp_date, 'DD-MM-YYYY').format('YYYY-MM-DD')
        : '';
    } else {
      estExpDate = this.validation.value.est_exp_date
        ? moment(this.validation.value.est_exp_date, 'DD-MM-YYYY').format('YYYY-MM-DD')
        : '';
    }

    if (this.mvpiExpToggle) {
      let mvpiExpVal = document.querySelector('#mvpi_exp_date')['value'];
      this.validation.get('mvpi_exp_date').setValue(mvpiExpVal);
      this.validation.updateValueAndValidity();

      mvpiExpDate = this.validation.value.mvpi_exp_date
        ? moment(this.validation.value.mvpi_exp_date, 'DD-MM-YYYY').format('YYYY-MM-DD')
        : '';
    } else {
      mvpiExpDate = this.validation.value.mvpi_exp_date
        ? moment(this.validation.value.mvpi_exp_date, 'DD-MM-YYYY').format('YYYY-MM-DD')
        : '';
    }

    this.submitted = true;

    if (this.validation.invalid) {
      return false;
    } else {
      //appending to formData
      this.form.set('vin_image', <string>this.validation.value.vin_img);
      this.form.set('plate_image', <string>this.validation.value.plate_img);
      this.form.set('mvpi_image', <string>this.validation.value.mvpi_img);
      this.form.set('estimara_image', <string>this.validation.value.est_img);
      this.form.set('odo_value', <string>this.validation.value.odo);
      this.form.set('odo_image', <string>this.validation.value.odo_img);
      this.form.set('estimara_expiry_date', <string>estExpDate);
      this.form.set('mvpi_expiry_date', <string>mvpiExpDate);
      this.form.set('vehicle_id', <string>this.vehicle_info.vehicle_id);

      this.submitLoad = true;
      this.userService.PostValidation(this.form).subscribe(
        (res) => {
          let success = res['success'];

          if (success) {
            this.submitLoad = false;
            this.toastr.success('Car details validated succssfully!', 'Success');
            this.router.navigate(['/vam/information']);
          } else {
            this.submitLoad = false;
            this.toastr.success('Something went wrong.', 'Error');
          }
        },
        (error: HttpErrorResponse) => {
          console.log('inside error block');
          console.log(error);
          const errorInfo = error?.error as IBaseResponse;
          if (errorInfo)
            this.toastr.error(`${errorInfo?.errors?.file?.[0] ?? error.error.message}`, 'Error');
          this.submitLoad = false;
          // this.toastr.error(`${error.error.message}`, 'Error');
        }
      );
    }
  }

  logout() {
    this.authService.setStatus({ status: true }).subscribe();
    this.authService.Logout();
    this.router.navigate(['/']);
  }
}
interface vehicle_info {
  vehicle_id: string;
}

// 5Y1SL65848Z411439
// 4227 JRQ

// 6L1SL65848Z411439
// 8927 ARQ

// 1k1SL65823Z411439
// 2627 ARJ
